import NacelleClient from '@nacelle/client-js-sdk'
import CompatibilityConnector from '@nacelle/compatibility-connector'
import LRU from 'lru-cache'
const cache = new LRU({ max: 50, max_age: 3000000 })

let routeCount = 0

const createClient = ($config, locale) => {
  // Initialize the Compatibility Connector
  const compatibilityConnector = new CompatibilityConnector({
    endpoint: $config.V2_NACELLE_ENDPOINT,
    token: $config.V2_NACELLE_GRAPHQL_TOKEN,
    locale // we can set the default locale here
  })
  // Initialize the SDK client
  const nacelleClient = new NacelleClient({
    connector: compatibilityConnector
  })
  return nacelleClient
}

export default ({ $config, store }, inject) => {
  const STORYBLOK_SPACE_AVAILABLE = !!($config.STORYBLOK_V2_NACELLE_ENDPOINT && $config.STORYBLOK_V2_NACELLE_GRAPHQL_TOKEN)
  const locale = 'en-us'
  const nacelleClient = createClient($config, locale)
  const nacelleContentClient = createClient($config, locale)
  const nacelleStoryblokClient = (STORYBLOK_SPACE_AVAILABLE)
    ? createClient({
        V2_NACELLE_ENDPOINT: $config.STORYBLOK_V2_NACELLE_ENDPOINT,
        V2_NACELLE_GRAPHQL_TOKEN: $config.STORYBLOK_V2_NACELLE_GRAPHQL_TOKEN,
      }, locale)
    : null
  const setSpace = async () => {
    const { commit } = store
    let space = await cache.get('space')
    routeCount += 1
    if (!space && routeCount > 1) {
      await new Promise(resolve => {
        setTimeout(() => {
          resolve(true)
        }, 500)
      })
      space = await cache.get('space')
    }
    if (!space) space = await nacelleClient.data.space()
    if (space) {
      await cache.set('space', space)
      const { id, name, domain, metafields, linklists } = space
      commit('space/setId', id)
      commit('space/setName', name)
      commit('space/setDomain', domain)
      commit('space/setMetafields', metafields)
      commit('space/setLinklists', linklists)
    }
  }

  const nacelleNuxtServerInit = async () => {
    await setSpace()
  }

  // FIXME this ain't a dynamic locale anymore..
  const plugin = {
    nacelleNuxtServerInit,
    setSpace,
    client: nacelleClient,
    data: nacelleClient.data,
    checkout: nacelleClient.checkout,
    events: nacelleClient.events,
    status: nacelleClient.status,
    locale,
    // mirrored so the preview connector doesn't break everything
    contentClient: nacelleContentClient,
    contentData: nacelleContentClient.data,
    // mirrored so we can use storyblok in some areas
    storyblokClient: nacelleStoryblokClient,
    storyblokData: STORYBLOK_SPACE_AVAILABLE ? nacelleStoryblokClient.data : null,
  }

  inject('nacelle', plugin)
}
